export default "__VITE_ASSET__BjGMg0Ff__"